import React from "react";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";

export default function OrderManagementHeader({ onRefreshOrders, onRefreshArticles, onCreateOrder }) {
    return (
        <Box
            sx={{
                borderBottom: "1px solid",
                borderColor: "divider",
                background: "linear-gradient(135deg, rgba(255,165,0,0.12) 0%, rgba(0,0,0,0.06) 100%)",
                py: { xs: 3, md: 4 },
            }}
        >
            <Container maxWidth="lg">
                <Stack
                    direction={{ xs: "column", md: "row" }}
                    spacing={2}
                    alignItems={{ xs: "flex-start", md: "center" }}
                    justifyContent="space-between"
                >
                    <Box>
                        <Typography variant="h4" sx={{ fontWeight: 900, letterSpacing: 0.2 }}>
                            Aufträge
                        </Typography>
                        <Typography variant="subtitle1" sx={{ mt: 0.5 }}>
                            Leistungen & Materialien erfassen – später in Rechnungen überführen.
                        </Typography>
                    </Box>
                    <Stack direction="row" spacing={1}>
                        <Button variant="outlined" startIcon={<RefreshRoundedIcon />} onClick={onRefreshOrders}>
                            Aufträge aktualisieren
                        </Button>
                        <Button variant="outlined" startIcon={<RefreshRoundedIcon />} onClick={onRefreshArticles}>
                            Artikel aktualisieren
                        </Button>
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "orange",
                                color: "#000",
                                fontWeight: 800,
                                "&:hover": { backgroundColor: "#ff9e1a" },
                            }}
                            onClick={onCreateOrder}
                        >
                            Neuer Auftrag
                        </Button>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
}
